import PropTypes from 'prop-types';
import React from 'react';
import ReactSpinkit from 'react-spinkit';
import styled from 'react-emotion';

import LoadingText from '../LoadingText/LoadingText';
import Style from '../../styles/common';

const Container = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Message = styled(LoadingText)`
  margin-top: ${Style.SPACING.XL};
`;

function Spinner(props) {
  return (
    <Container>
      <ReactSpinkit color={Style.color.SPINNER} name="chasing-dots" />
      <Message>{props.message}</Message>
    </Container>
  );
}

Spinner.propTypes = {
  isLoading: PropTypes.bool,
  message: PropTypes.string,
};

Spinner.defaultProps = {
  isLoading: false,
  message: '',
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js